<template>
  <StackPageLayout @close="handleClose">
    <template #title> Edit Category </template>

    <div
      class="flex min-h-full flex-col rounded-lg bg-background p-3"
    >
      <CategoryForm
        :category-id="categoryId"
        @submit="handleSubmit"
      />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import { updateCategory } from "@/services/categories/updateCategory"
import { type CategoryFormOutput } from "@/forms/categoryForm"

const { startLoading, stopLoading } =
  usePageBlockingLoading()

const router = useRouter()
const props = defineProps<{ categoryId: string }>()

const handleClose = () =>
  router.push({ name: "settingsCategoryIndex" })

const handleSubmit = async (params: CategoryFormOutput) => {
  startLoading()
  try {
    await updateCategory(props.categoryId, params)
    toast.success("Category updated")
    router.push({ name: "settingsCategoryIndex" })
  } catch {
    toast.error("Failed to update category")
  } finally {
    stopLoading()
  }
}
</script>
